import React, { useState, useEffect} from "react";
import { get } from 'lodash'

import LeftNavigation from "./left-navigation"
import RightNavigation from "./right-navigation"
import ProductFooter from "./Footer"
import ProductHeader from "./Header"
import '../../product-css/compiled/app.css'
import { withBTScriptLoader } from '../hoc'
import { initProductLayout, clearProductLayout } from "./left-navigation/utils";
import SEO from "../SEO";


const components = {
  product_header: ProductHeader,
  product_footer: ProductFooter
}

export const getComponentFromConfig = (config) => components[config.react_component]

const Layout = ({
  hideLeftNav,
  hideRightNav,
  hideMenu,
  children,
  config,
  location,
  leftNav,
  context,
  pageHeader,
  isProductPage
}) => {
  const [isArticles, setIsArticles] = useState(false)
const { header, footer, page: { left } } = get(config, 'layout', {})
const [showMobileMenu, setShowMobileMenu] = useState(false)
const toggleMobileMenu = () => {
setShowMobileMenu(!showMobileMenu)
}

  useEffect(() => {
    initProductLayout(config.layout.page)
    const _isArticles = location.pathname.split('/')[1] === 'articles'
    setIsArticles(_isArticles)
    return () => clearProductLayout()
  }, [location.pathname])  

  useEffect(()=>{
    window.BTAnalyticsLib.loadAnalytics()
  },[])

  const Header = getComponentFromConfig(header)
  const Footer = getComponentFromConfig(footer)
  const mainClassName =  isProductPage ? "main-content container--center" : `${isArticles ? 'articles-content__wrapper ' : 'documentation-content__wrapper '}`
  return (
    <>
    <SEO context={context} />
    <div className={`root ${isArticles ? 'support articles' : ''} ${showMobileMenu ? 'off-canvas-menu-open' : ''}`}>
    <div className="flex app" data-track-event-context="content">
      <Header config={header} location={location} context={context}/>
      { hideMenu ? null :
      <button  onClick={toggleMobileMenu} className="button button--small menu__button js-off-canvas">
        <span className="menu__button-text">Menu</span>
      </button>}
      <div className={`flex-body ${isArticles ? 'support-article' : ''}`}>
        
        {!hideLeftNav ?
        (<div className={`flex-sidebar ${isArticles ? 'articles-sidebar' : 'documentation-sidebar'}`}>
                    <LeftNavigation location={location} config={left} leftNav={leftNav} />
                    </div>)  : null}
        
        <div className="flex-content">
          <main id="main-section" className={mainClassName } >
            {/* <div className="page-header page-header--guides {{isTitleHidden}}">
              {{> documentation_title_block_content }}
            </div> */}
            {pageHeader}
            <article className={` ${!hideLeftNav ? 'flex--constrained' : ''} main-content js-outlet {{jsViewclassName}}" `} data-track-event-context="content">
              {children}
            </article>
            {!hideRightNav ? (
                    <RightNavigation />
                  ) : null}
          </main>
          <Footer config={footer} location={location} context={context}/>
        </div>
      </div> 
       
      </div>
    </div>
    </>
  );
};

Layout.defaultProps = {
  hideLeftNav: false,
  hideRightNav: false,
}

export default withBTScriptLoader(Layout)


